import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { connectSocket, disconnectSocket, getSocket, onSocketStatusChange } from '../services/socket'
import { getAuthToken } from '../services/api'

const SocketContext = createContext(null)

export const SocketProvider = ({ children }) => {
  const [connected, setConnected] = useState(false)

  useEffect(() => {
    const unsubscribe = onSocketStatusChange((nextStatus) => {
      setConnected(nextStatus)
    })

    return () => {
      unsubscribe()
      disconnectSocket()
    }
  }, [])

  const initializeSocket = () => {
    if (!getAuthToken()) {
      setConnected(false)
      return null
    }
    return connectSocket()
  }

  const value = useMemo(
    () => ({
      socket: getSocket(),
      connected,
      initializeSocket,
      disconnectSocket,
    }),
    [connected]
  )

  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
}

export const useSocket = () => {
  return useContext(SocketContext)
}
